// zone.js が包んだエラーは zone や task への循環参照を持つので、そのまま JSON.stringify すると例外になる。
// 循環参照は "[Circular]" に置き換え、Error は message と stack を取り出してシリアライズする
export function safeStringify(value: any): string {
  const seen: any[] = []
  try {
    const json = JSON.stringify(value, (_key, val) => {
      if (typeof val !== 'object' || val === null) return val
      if (seen.indexOf(val) !== -1) return '[Circular]'
      seen.push(val)
      if (val instanceof Error) {
        // message や stack は列挙されないので明示的に取り出す (rejection などの独自プロパティも残す)
        const plain: any = { name: val.name, message: val.message, stack: val.stack }
        Object.keys(val).forEach(k => plain[k] = (val as any)[k])
        return plain
      }
      return val
    })
    return json === undefined ? String(value) : json
  } catch (e) {
    return String(value)
  }
}



// WEBPACK FOOTER //
// ./src/app/safe-stringify.ts